<template>
    <div class="user">
        <div class="headerbg">
            <b-container class="d-flex align-items-center justify-content-between">
                <h1>{{ title }}</h1>
                <b-button variant="outline-secondary" size="sm" @click="logout">登出</b-button>
            </b-container>
        </div>
        <b-container fluid="xl">
            <b-row>
                <b-col cols="12" md="2">
                    <nacUser></nacUser>
                </b-col>
                <b-col cols="12" md="10">
                    <b-card class="mb-3">
                        <template #header>
                            <span class="font-weight-bold">訂單管理</span>
                        </template>
                        <div class="responsive">
                            <BTableV1 :TablePage="TablePage" :cell="['TotalPrice', 'Create', 'tool']">
                                <template #Create="{row}">
                                    {{ row.item.Create | datefmt('YYYY-MM-DD HH:mm:ss') }}
                                </template>
                                <template #TotalPrice="{row}">
                                    <div v-if="row.item.Discount == 0">{{ row.item.TotalPrice  | money(0,2)}}</div>
                                    <div v-if="row.item.Discount != 0">
                                        <div>
                                            <span style="text-decoration: line-through;">
                                                {{ row.item.TotalPrice | money(0,2)}}</span
                                            >
                                        </div>
                                        <div>{{ (row.item.TotalPrice + row.item.Discount )  | money(0,2)}}</div>
                                    </div>
                                </template>

                                <template #tool="{row}">
                                    <b-button variant="primary" @click="TableGo(row.item.OrderNo)" size="sm"
                                        >詳細資料</b-button
                                    >
                                </template>
                            </BTableV1>
                        </div>
                        <template v-if="TablePage.items.length > 0">
                            <div class="overflow-auto mt-5">
                                <b-pagination
                                    align="center"
                                    v-model="Param.Paging.pageNumber"
                                    :total-rows="rows"
                                    :per-page="Param.Paging.pageSize"
                                ></b-pagination>
                            </div>
                        </template>
                    </b-card>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>
<script>
    import nacUser from '@/components/nacUser.vue';
    import BTableV1 from '../../components/BTableV1.vue';
    import { apiOrderList } from '@/api/API.js';
    export default {
        name: 'user-signin',
        components: {
            nacUser,
            BTableV1,
        },
        data() {
            return {
                Param: {
                    Paging: {
                        pageNumber: 1,
                        pageSize: 10,
                    },
                    Search: {},
                },
                pageHeader: '',

                title: '課程訂單',
                TablePage: {
                    title: '',
                    class: '',
                    BT_style: { striped: true, hover: true },
                    PG_style: {
                        pills: true,
                        align: 'center',
                        'first-text': '第一頁',
                        'prev-text': '上一頁',
                        'next-text': '下一頁',
                        'last-text': '最後一頁',
                    },
                    itemsAll: [],
                    items: [],
                    id: 'Table1',
                    currentPage: 1,
                    rows: 100,
                    page: 10,
                    sortBy: '',
                    sortDesc: false,
                    sortDirection: 'asc',
                    filter: null,
                    filterOn: [],
                    fields: [
                        { key: 'Create', label: '訂單日期' },
                        { key: 'OrderNo', label: '訂單編號', sortable: false },
                        { key: 'TotalPrice', label: '訂單總額', sortable: false },
                        { key: 'tool', label: '操作', sortable: false },
                    ],

                    TIndex(th1, index) {
                        return (th1.currentPage - 1) * th1.page + index;
                    },
                    clear(th1) {
                        th1.itemsAll = [];
                        th1.items = [];
                        th1.rows = 0;
                        th1.currentPage = 1;
                    },
                    set(th1, data) {
                        th1.itemsAll = JSON.parse(JSON.stringify(data));
                        th1.items = JSON.parse(JSON.stringify(data));
                        th1.rows = data.length;
                    },
                    set2(th1, data) {
                        th1.items = JSON.parse(JSON.stringify(data));
                        th1.rows = data.length;
                        th1.currentPage = 1;
                    },
                    set3(th1, data) {
                        th1.items = JSON.parse(JSON.stringify(data));
                        th1.rows = data.length;
                        th1.currentPage = 1;
                    },
                },
            };
        },
        watch: {
            'Param.Paging.pageNumber'(newVal) {
                if (newVal) {
                    this.GetList(newVal);
                }
            },
        },
        mounted() {
            if (this.IsNull(this._sessionData('TokenID')) == '') {
                alert('尚未登入');
                this._go('/');
            }
            this.Init();
        },
        methods: {
            logout() {
                const data1 = this._storeData('Header_form1');
                if (this.IsNull(data1) !== '') {
                    data1.text = '學員登入';
                }
                this._sessionData('NewToken', '');
                this._sessionData('TokenID', '');
                this._sessionData('campCartCachedCount', '');
                this._sessionData('courseCartCachedCount', '');
                this._go('/');
            },
            TableGo(data) {
                this.$store.commit('setOrderNo', data);
                this._go('myRegistration');
            },

            async Init() {
                this.GetList();
            },
            GetList(val) {
                this.TablePage.items = [];
                this.loadSet.show = true;
                this.Param.Paging.pageNumber = val;
                apiOrderList(this.Param)
                    .then((res) => {
                        this.TablePage.items = res.data;
                        this.pageHeader = JSON.parse(res.headers['list-header']).Paging;
                        this.rows = this.pageHeader.totalCount;
                        this.loadSet.show = false;
                    })
                    .catch((err) => {
                        this.loadSet.show = false;
                        console.log(err.response);
                    });
            },
        },
    };
</script>
